// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../reason/next/Next.bs.js");
let React = require("react");
let IconV5 = require("../v5/common/Components/IconV5.bs.js");
let Tooltip = require("../v5/common/Components/Tooltip.bs.js");
let Intercom = require("../reason/common/Intercom.bs.js");
let AuthSession = require("../utils/AuthSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RelayRuntime = require("relay-runtime");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AlertsDropdownItem = require("./AlertsDropdownItem.bs.js");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactAriaComponents = require("react-aria-components");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let AnimatedNotificationCount = require("./NotificationAlert/AnimatedNotificationCount.bs.js");
let RequireAuthenticatedAgent = require("../hoc/RequireAuthenticatedAgent.bs.js");
let AlertsDropdownQuery_graphql = require("../__generated__/AlertsDropdownQuery_graphql.bs.js");
let RescriptRelay_Subscriptions = require("rescript-relay/src/RescriptRelay_Subscriptions.bs.js");
let AlertsDropdown_query_graphql = require("../__generated__/AlertsDropdown_query_graphql.bs.js");
let AlertsDropdownAlertsSection_alerts_graphql = require("../__generated__/AlertsDropdownAlertsSection_alerts_graphql.bs.js");
let AlertsDropdownDismissAlertMutation_graphql = require("../__generated__/AlertsDropdownDismissAlertMutation_graphql.bs.js");
let AlertsDropdownNewAlertsSubscription_graphql = require("../__generated__/AlertsDropdownNewAlertsSubscription_graphql.bs.js");
let AlertsDropdownDismissAlertGroupMutation_graphql = require("../__generated__/AlertsDropdownDismissAlertGroupMutation_graphql.bs.js");

let noAlertsView = JsxRuntime.jsxs("div", {
  children: [
    JsxRuntime.jsx(IconV5.make, {
      icon: "no-alerts-bell",
      className: "mb-6 text-[60px] sm:mb-2.5 sm:text-2xl"
    }),
    JsxRuntime.jsx("span", {
      children: "You don't have any alerts"
    })
  ],
  className: "w-full h-full flex flex-col items-center justify-center text-base uppercase text-zinc-500 bg-white sm:text-[13px] sm:px-5 sm:py-2.5"
});

let alertsListConnectionId = AlertsDropdown_query_graphql.makeConnectionId(RelayRuntime.ROOT_ID);

let convertVariables = AlertsDropdownDismissAlertGroupMutation_graphql.Internal.convertVariables;

let convertResponse = AlertsDropdownDismissAlertGroupMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = AlertsDropdownDismissAlertGroupMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AlertsDropdownDismissAlertGroupMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, AlertsDropdownDismissAlertGroupMutation_graphql.node, convertResponse, convertWrapRawResponse);

let DismissAlertGroupMutation_alertGroup_decode = AlertsDropdownDismissAlertGroupMutation_graphql.Utils.alertGroup_decode;

let DismissAlertGroupMutation_alertGroup_fromString = AlertsDropdownDismissAlertGroupMutation_graphql.Utils.alertGroup_fromString;

let DismissAlertGroupMutation = {
  alertGroup_decode: DismissAlertGroupMutation_alertGroup_decode,
  alertGroup_fromString: DismissAlertGroupMutation_alertGroup_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = AlertsDropdownDismissAlertMutation_graphql.Internal.convertVariables;

let convertResponse$1 = AlertsDropdownDismissAlertMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = AlertsDropdownDismissAlertMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, AlertsDropdownDismissAlertMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, AlertsDropdownDismissAlertMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let DismissAlertMutation_alertGroup_decode = AlertsDropdownDismissAlertMutation_graphql.Utils.alertGroup_decode;

let DismissAlertMutation_alertGroup_fromString = AlertsDropdownDismissAlertMutation_graphql.Utils.alertGroup_fromString;

let DismissAlertMutation_alertStatus_decode = AlertsDropdownDismissAlertMutation_graphql.Utils.alertStatus_decode;

let DismissAlertMutation_alertStatus_fromString = AlertsDropdownDismissAlertMutation_graphql.Utils.alertStatus_fromString;

let DismissAlertMutation = {
  alertGroup_decode: DismissAlertMutation_alertGroup_decode,
  alertGroup_fromString: DismissAlertMutation_alertGroup_fromString,
  alertStatus_decode: DismissAlertMutation_alertStatus_decode,
  alertStatus_fromString: DismissAlertMutation_alertStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

let convertFragment = AlertsDropdownAlertsSection_alerts_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment, fRef);
}

let AlertsFragment_alertGroup_decode = AlertsDropdownAlertsSection_alerts_graphql.Utils.alertGroup_decode;

let AlertsFragment_alertGroup_fromString = AlertsDropdownAlertsSection_alerts_graphql.Utils.alertGroup_fromString;

let AlertsFragment = {
  alertGroup_decode: AlertsFragment_alertGroup_decode,
  alertGroup_fromString: AlertsFragment_alertGroup_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$2,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AlertsDropdown$AlertsSection(props) {
  let onDismiss = props.onDismiss;
  let group = props.group;
  let alerts = RescriptRelay_Fragment.useFragment(AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment, props.filteredAlerts);
  let match = use();
  let isDismissingAlertGroup = match[1];
  let dismissAlertGroup = match[0];
  let isImpersonated = AuthSession.useIsImpersonated();
  let tmp;
  tmp = group === "CONVERSATIONS" ? "Conversations" : "Match";
  let dismissAlertGroupLink = JsxRuntime.jsx("a", {
    children: JsxRuntime.jsx(IconV5.make, {
      icon: "cancel"
    }),
    className: "text-zinc-500 no-underline hover:text-zinc-700",
    href: "#",
    onClick: e => {
      e.preventDefault();
      if (!isImpersonated && !isDismissingAlertGroup) {
        dismissAlertGroup({
          connections: [alertsListConnectionId],
          input: {
            group: group
          }
        }, undefined, {
          dismissAlertsByGroupV5: {
            __typename: "AlertsGroupDismissed",
            deletedAlertNodeIds: alerts.map(alert => alert.nodeId)
          }
        }, undefined, undefined, undefined, undefined);
        return;
      }
    }
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("h4", {
        children: [
          tmp,
          isImpersonated ? JsxRuntime.jsx(Tooltip.make, {
              label: "You cannot dismiss alerts when you are impersonated.",
              children: dismissAlertGroupLink
            }) : dismissAlertGroupLink
        ],
        className: "flex items-center justify-between bg-zinc-200 text-zinc-700 px-4 py-3 font-semibold uppercase"
      }),
      JsxRuntime.jsx("div", {
        children: alerts.map(v => JsxRuntime.jsx(AlertsDropdownItem.make, {
          alert: v.fragmentRefs,
          onDismiss: () => onDismiss(v.id)
        }, v.id)),
        className: "divide-y divide-gray-200"
      })
    ],
    className: ""
  });
}

let AlertsSection = {
  AlertsFragment: AlertsFragment,
  make: AlertsDropdown$AlertsSection
};

let convertVariables$2 = AlertsDropdownQuery_graphql.Internal.convertVariables;

let convertResponse$2 = AlertsDropdownQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = AlertsDropdownQuery_graphql.Internal.convertWrapRawResponse;

let use$3 = RescriptRelay_Query.useQuery(convertVariables$2, AlertsDropdownQuery_graphql.node, convertResponse$2);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$2, AlertsDropdownQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(AlertsDropdownQuery_graphql.node, convertResponse$2, prim => prim);

let fetch = RescriptRelay_Query.fetch_(AlertsDropdownQuery_graphql.node, convertResponse$2, convertVariables$2);

let fetchPromised = RescriptRelay_Query.fetchPromised(AlertsDropdownQuery_graphql.node, convertResponse$2, convertVariables$2);

let retain = RescriptRelay_Query.retain(AlertsDropdownQuery_graphql.node, convertVariables$2);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  use: use$3,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertFragment$1 = AlertsDropdown_query_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AlertsDropdown_query_graphql.node, convertFragment$1, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(AlertsDropdown_query_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AlertsDropdown_query_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AlertsDropdown_query_graphql.node, convertFragment$1, fRef);
}

let QueryFragment_getConnectionNodes = AlertsDropdown_query_graphql.Utils.getConnectionNodes;

let QueryFragment_alertGroup_decode = AlertsDropdown_query_graphql.Utils.alertGroup_decode;

let QueryFragment_alertGroup_fromString = AlertsDropdown_query_graphql.Utils.alertGroup_fromString;

let QueryFragment_alertStatus_decode = AlertsDropdown_query_graphql.Utils.alertStatus_decode;

let QueryFragment_alertStatus_fromString = AlertsDropdown_query_graphql.Utils.alertStatus_fromString;

let QueryFragment = {
  getConnectionNodes: QueryFragment_getConnectionNodes,
  alertGroup_decode: QueryFragment_alertGroup_decode,
  alertGroup_fromString: QueryFragment_alertGroup_fromString,
  alertStatus_decode: QueryFragment_alertStatus_decode,
  alertStatus_fromString: QueryFragment_alertStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$4,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertVariables$3 = AlertsDropdownNewAlertsSubscription_graphql.Internal.convertVariables;

let convertResponse$3 = AlertsDropdownNewAlertsSubscription_graphql.Internal.convertResponse;

let subscribe = RescriptRelay_Subscriptions.subscribe(AlertsDropdownNewAlertsSubscription_graphql.node, convertVariables$3, convertResponse$3);

let Subscription_alertGroup_decode = AlertsDropdownNewAlertsSubscription_graphql.Utils.alertGroup_decode;

let Subscription_alertGroup_fromString = AlertsDropdownNewAlertsSubscription_graphql.Utils.alertGroup_fromString;

let Subscription = {
  alertGroup_decode: Subscription_alertGroup_decode,
  alertGroup_fromString: Subscription_alertGroup_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  subscribe: subscribe
};

function AlertsDropdown$Dropdown(props) {
  let query = use$3(undefined, undefined, undefined, undefined);
  let data = RescriptRelay_Fragment.useFragment(AlertsDropdown_query_graphql.node, convertFragment$1, query.fragmentRefs);
  let match = use$1();
  let dismissAlert = match[0];
  let match$1 = React.useState(() => false);
  let setIsOpened = match$1[1];
  let isOpened = match$1[0];
  let router = Next.useRouter();
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  React.useEffect(() => {
    let subscription = subscribe(environment, {
      connections: [alertsListConnectionId]
    }, undefined, undefined, undefined, undefined);
    return () => {
      subscription.dispose();
    };
  }, []);
  React.useEffect(() => {
    setIsOpened(param => false);
  }, [Next.Router.asPath(router)]);
  let alerts = Stdlib_Option.getOr(Stdlib_Option.map(data.alertsForCurrentUser, v => Stdlib_Array.keepSome(v.edges).map(e => e.node).filter(alert => alert.status === "NEW")), []);
  let conversationAlerts = alerts.filter(alert => alert.grouping === "CONVERSATIONS").map(v => v.fragmentRefs);
  let matchAlerts = alerts.filter(alert => alert.grouping === "MATCHES").map(v => v.fragmentRefs);
  let isEmpty = alerts.length === 0;
  let onDismiss = id => {
    dismissAlert({
      connections: [alertsListConnectionId],
      input: {
        id: id
      }
    }, undefined, undefined, undefined, undefined, undefined, undefined);
  };
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs(ReactAriaComponents.DialogTrigger, {
        children: [
          JsxRuntime.jsxs(ReactAriaComponents.Button, {
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: isOpened ? "bell-filled" : "bell",
                size: 22
              }),
              JsxRuntime.jsx(AnimatedNotificationCount.make, {
                count: alerts.length,
                isOpened: isOpened
              })
            ],
            className: param => TailwindMerge.twMerge([
              "flex w-6 border-none p-0 bg-none text-[22px] relative cursor-pointer sm:text-zinc-500",
              "z-20 text-zinc-500"
            ]),
            isDisabled: isEmpty
          }),
          innerWidth < 545 ? JsxRuntime.jsx(ReactAriaComponents.ModalOverlay, {
              children: JsxRuntime.jsx(ReactAriaComponents.Modal, {
                children: JsxRuntime.jsx(ReactAriaComponents.Dialog, {
                  children: isEmpty ? noAlertsView : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        conversationAlerts.length !== 0 ? JsxRuntime.jsx(AlertsDropdown$AlertsSection, {
                            group: "CONVERSATIONS",
                            filteredAlerts: conversationAlerts,
                            onDismiss: onDismiss
                          }) : null,
                        matchAlerts.length !== 0 ? JsxRuntime.jsx(AlertsDropdown$AlertsSection, {
                            group: "MATCHES",
                            filteredAlerts: matchAlerts,
                            onDismiss: onDismiss
                          }) : null
                      ]
                    }),
                  "aria-label": "Alerts",
                  className: "p-0 m-0 rounded-none"
                }),
                className: param => TailwindMerge.twMerge([
                  "fixed inset-x-0 w-full rounded-none bg-white shadow-md overflow-auto p-0 m-0",
                  Intercom.isBannerVisible() ? "top-[100px] max-h-[calc(100vh-100px)]" : "top-[66px] max-h-[calc(100vh-66px)]"
                ]),
                isDismissable: true
              }),
              isDismissable: true,
              className: param => "z-[1000]"
            }) : JsxRuntime.jsx(ReactAriaComponents.Popover, {
              children: JsxRuntime.jsx(ReactAriaComponents.Dialog, {
                children: isEmpty ? noAlertsView : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      conversationAlerts.length !== 0 ? JsxRuntime.jsx(AlertsDropdown$AlertsSection, {
                          group: "CONVERSATIONS",
                          filteredAlerts: conversationAlerts,
                          onDismiss: onDismiss
                        }) : null,
                      matchAlerts.length !== 0 ? JsxRuntime.jsx(AlertsDropdown$AlertsSection, {
                          group: "MATCHES",
                          filteredAlerts: matchAlerts,
                          onDismiss: onDismiss
                        }) : null
                    ]
                  }),
                "aria-label": "Alerts",
                className: "p-0"
              }),
              className: TailwindMerge.twMerge([
                isEmpty ? "sm:right-0 sm:w-[234px] sm:-translate-x-[50%] sm:left-[11px]" : "sm:right-4 sm:w-[480px] sm:left-auto",
                "rounded-md bg-white shadow-md sm:max-h-[400px] overflow-auto z-[999]"
              ])
            })
        ],
        isOpen: isOpened,
        onOpenChange: newOpen => setIsOpened(param => newOpen)
      }),
      className: TailwindMerge.twMerge([
        "flex self-stretch relative items-center",
        isOpened ? "before:w-0 before:h-0 before:border-style-solid before:border-t-0 before:border-r-[9px] before:border-b-[10px] before:border-l-[9px] before:border-transparent before:border-b-zinc-200 before:content-[''] before:absolute before:bottom-0 before:z-20 before:left-1 z-[2000]" : ""
      ])
    }),
    className: "flex self-stretch items-center"
  });
}

let Dropdown = {
  make: AlertsDropdown$Dropdown
};

function AlertsDropdown(props) {
  return JsxRuntime.jsx(React.Suspense, {
    children: JsxRuntime.jsx(RequireAuthenticatedAgent.make, {
      children: JsxRuntime.jsx(AlertsDropdown$Dropdown, {}),
      loaderComponent: null
    }),
    fallback: null
  });
}

let make = AlertsDropdown;

exports.noAlertsView = noAlertsView;
exports.alertsListConnectionId = alertsListConnectionId;
exports.DismissAlertGroupMutation = DismissAlertGroupMutation;
exports.DismissAlertMutation = DismissAlertMutation;
exports.AlertsSection = AlertsSection;
exports.Query = Query;
exports.QueryFragment = QueryFragment;
exports.Subscription = Subscription;
exports.Dropdown = Dropdown;
exports.make = make;
/* noAlertsView Not a pure module */
